import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import Config from 'common/config/config'
import { ProductImage, Stepper, Price } from 'components'
import productStyleController from '@ctrls/productStyleController'
import './index.scss'

// interface
interface IProps {
  product: IViewProduct;
  decorate?: TMealCommonDecorates;
  style?: any;
  full?: boolean;
  imgLoaded?: boolean;
  lazy?: boolean;
  onClick: (product) => void;
}
// 瀑布流图片的宽度
const ProductItem: FC<IProps> = ({ product, decorate, style, imgLoaded = false, lazy = false, full = false, onClick }) => {
  let { no, name, price, offPrice, memberPrice, actualPrice } = product || {}
  const ecolor = Config.colorImages[product.categories[0]?.charCodeAt(0) % 4]

  /** 获得图片的宽高 */
  const [productStyle] = useState(() => {
    const imgWidth = full ? window.innerWidth - productStyleController.getWidthPer(8) : window.innerWidth / 2 - productStyleController.getWidthPer(5)
    const imgHeight = imgWidth * Number(product.picHeight || 360) / Number(product.picWidth || 360)
    return {
      width: imgWidth,
      height: imgHeight
    }
  })

  const [defaultImg, setDefault] = useState<string>('')

  const handleClick = () => {
    onClick(product)
  }

  useEffect(() => {
    const imgArr = JSON.parse(product.pics || '[]')
    const defaultItem = imgArr.filter(item => item.default !== 0)
    const defaultImgUrl: string = defaultItem.length ? (defaultItem[0].type === 'video' ? defaultItem[0].videoImageUrl : product.pic) : product.pic
    setDefault(defaultImgUrl)
  }, [product])

  return (
    <div
      className='exchange-product-item'
      style={style ? {
        visibility: style.left ? 'visible' : 'hidden',
        left: style.left,
        top: style.top
      } : null}
      id={`exchangeproduct${no}`}
      data-cypid={`exchangeproduct${no}`}
      onClick={handleClick}
    >
      {
        !defaultImg
          ? (
            <div
              className='watercolor' style={{
                backgroundColor: ecolor
              }}
            >
            </div>
          ) : (
            <ProductImage
              color={!defaultImg ? product.no : ''}
              imgSrc={(imgLoaded || !lazy) ? defaultImg : ''}
              width={productStyle.width}
              height={productStyle.height}
              className='waterfall-img'
            />
          )
      }
      <div className='product-info'>
        <div className='product-name' style={{ fontSize: `${decorate?.fontSetting?.name?.fontSize || 16}px`, fontWeight: decorate?.fontSetting?.name?.fontWeight ? 700 : 500 }}>{name}</div>
        <div className='scale-name'>{product.scales?.length ? product.scales[0].name : ''}</div>
        <div className='product-actions'>
          <Price
            decorate={decorate}
            className='product-price'
            price={price}
            actualPrice={actualPrice}
            offPrice={offPrice}
            memberPrice={memberPrice}
          />
          <Stepper cnt={0} onChange={handleClick} hideMinus />
        </div>
      </div>
    </div>
  )
}
export default observer(ProductItem)
